import { useEffect } from "react";

const LS_USER_META = "auth.user.meta";
const LS_VERSION   = "auth.version";
const CHANNEL_NAME = "auth";

// ---------- Internal utilities ----------

function safeParse(json) {
  try { return JSON.parse(json); } catch { return null; }
}

function bumpVersion() {
  localStorage.setItem(LS_VERSION, String(Date.now()));
}

function broadcast(message) {
  if ("BroadcastChannel" in window) {
    const bc = new BroadcastChannel(CHANNEL_NAME);
    try { bc.postMessage(message); } finally { bc.close(); }
  }
}

// ---------- Public API ----------

export function saveAuthMeta(meta) {
  if (meta && typeof meta === "object") {
    localStorage.setItem(LS_USER_META, JSON.stringify(meta));
  } else {
    localStorage.removeItem(LS_USER_META);
  }
  bumpVersion();
  broadcast({ type: "auth-change" });
}

export function clearAuthMeta() {
  localStorage.removeItem(LS_USER_META);
  bumpVersion();
  broadcast({ type: "auth-change" });
}

export function readAuthMeta() {
  return safeParse(localStorage.getItem(LS_USER_META));
}

export function hasDifferentLoggedUser(email) {
  const meta = readAuthMeta();
  return Boolean(meta?.email && email && meta.email !== email);
}

export function useCrossTabAuthSync(onChange) {
  useEffect(() => {
    let bc = null;
    if ("BroadcastChannel" in window) {
      bc = new BroadcastChannel(CHANNEL_NAME);
      bc.onmessage = (ev) => {
        if (ev?.data?.type === "auth-change") onChange?.(readAuthMeta());
      };
    }

    const onStorage = (e) => {
      if (e.key === LS_VERSION || e.key === LS_USER_META) {
        onChange?.(readAuthMeta());
      }
    };
    window.addEventListener("storage", onStorage);

    return () => {
      window.removeEventListener("storage", onStorage);
      bc?.close?.();
    };
  }, [onChange]);
}
